import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { IAddress } from '../../shared/models/address.model';
import { ICountySelectListModel } from '../../shared/models/county-select-list.model';
import { ISelectList } from '../../shared/models/select-list.model';
import { BusinessService } from '../../shared/services/business/business.service';
import { LookupsService } from '../../shared/services/lookups/lookups.service';
import { MessageService } from '../../shared/services/message/message.service';
import { GatekeeperModalComponent } from '../modal.component';

@Component({
  selector: 'gk-edit-address-modal',
  templateUrl: './edit-address-modal.component.html'
})
export class EditAddressModalComponent
  extends GatekeeperModalComponent<EditAddressModalComponent>
  implements OnInit
{
  countyList: ICountySelectListModel[];
  countryList: ISelectList[];
  businessId: number;
  address: IAddress;
  currentAddress: IAddress;

  constructor(
    private lookupsService: LookupsService,
    private messageService: MessageService,
    private businessService: BusinessService,
    public dialogRef: MatDialogRef<EditAddressModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();

    this.businessId = data.locals.businessId;
    this.address = _.cloneDeep(data.locals.address);
    this.currentAddress = _.cloneDeep(data.locals.address);
  }

  ngOnInit() {
    this.lookupsService.counties$.subscribe(
      counties => (this.countyList = counties),
      () =>
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'BUSINESS_NOT_LOADED',
          { name: '' }
        )
    );

    this.lookupsService.countries$.subscribe(
      countries => (this.countryList = countries),
      () =>
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          'BUSINESS_NOT_LOADED',
          { name: '' }
        )
    );
  }

  saveAddress(): Promise<any> {
    return this.businessService
      .saveAddress(this.businessId, this.address)
      .then(() => {
        this.messageService.showIcon(MessageTypeEnum.Success);
        return this.businessService.loadBusinessSummaries();
      })
      .then(() => this.close(this.address))
      .catch(r =>
        this.messageService.showMessage(
          MessageTypeEnum.Danger,
          r.error.detail,
          { name: '' }
        )
      );
  }
}
